import { Moment } from "moment";
import { useTranslation } from "react-i18next";

export function LocalizedDateTime({ dateTime }: { dateTime: Moment }) {
  const { t } = useTranslation();
  const currentTimezoneId = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const timezoneParts = currentTimezoneId.split("/");
  let currentCity = "";
  if (timezoneParts.length > 1) {
    currentCity = timezoneParts[timezoneParts.length - 1].replace(/_/g, " ");
  } else {
    currentCity = currentTimezoneId;
  }

  return <>{dateTime.format(t("datetimesec_format")) + ` (${currentCity})`}</>;
}
